import * as countryCodeActions from '../actions/countryCodes';

const initialState = {
    countryCodes: [],
    setCountry: null
}

export default (state = initialState, action) => {
    switch(action.type){
        case countryCodeActions.UPDATE_COUNTRY_CODES:
            return {
                ...state,
                countryCodes: action.countryCodes
            }
        case countryCodeActions.SET_COUNTRY_BY_IP:
            return {
                ...state,
                setCountry: action.country
            }
        default:
            return state;
    }
};